const spacing = 5;
const mediumSpacing = '5%';
const mobileSpacing = 4;

export const blogDetailsHeroWrapperStyles = (backgroundColor: string) => ({
	backgroundColor,
	paddingX: { xs: `1rem`, sm: mediumSpacing, md: `${spacing}rem`, lg: `${spacing}rem` },
	paddingY: { xs: `${mobileSpacing}rem`, sm: `${spacing}rem` },
	paddingRight: { sm: 0, md: 0, lg: 0 },
});

export const blogDetailsHeroLeftStyles = {
	position: 'relative',
	display: 'flex',
	flexFlow: 'column',
	gap: '1.5rem',
	paddingRight: { xs: 0, sm: mediumSpacing, md: mediumSpacing, lg: `${spacing * 2}rem` },
	paddingBottom: { xs: `${mobileSpacing}rem`, md: 0 },
};

export const blogDetailsHeroRightStyles = {
	display: 'flex',
	flexFlow: 'column',
	gap: '1.5rem',
};

export const blogDetailsHeroInfoStyles = {
	display: 'flex',
	flexFlow: 'row no-wrap',
	gap: '1rem',
	justifyContent: { xs: 'center', sm: 'flex-start' },
};

export const blogDetailsHeroBackLinkStyles = {
	position: { xs: 'relative', sm: 'absolute' },
	top: `-${spacing / 2 + 0.5}rem`,
	display: { xs: 'none', md: 'flex' },
	flexFlow: 'row no-wrap',
	alignItems: 'center',
};

export const blogDetailsHeroTakeAwaysStyles = {
	paddingTop: '1.5rem',
	borderTop: '1px solid',
	borderColor: 'neutrals.disabled',
};

export const heroContentBoxStyles = {
	display: 'flex',
	flexFlow: { sm: 'column', md: 'row nowrap' },
	gap: '1.5rem',
	paddingRight: { sm: '2rem', md: '10%' },
};

export const blogAuthorListGridStyles = (withImage?: boolean) => {
	const columnsGrid = withImage ? { xs: 'auto 1fr', sm: 'auto 1fr 1fr' } : { xs: '1fr', sm: '1fr 1fr' };
	return {
		display: 'grid',
		gap: '1.5rem',
		gridTemplateColumns: columnsGrid,
		gridTemplateRows: { xs: 'auto auto', sm: '' },
	};
};

export const blogAuthorGridImageStyles = {
	marginTop: '-30%',
	marginBottom: '1rem',
	gridRow: '1 / 3',
	position: { xs: 'relative' },
};

export const blogAuthorStyles = {
	borderRight: { xs: '', sm: '1px solid' },
	borderColor: { sm: 'neutrals.disabled' },
	paddingRight: { xs: '', sm: '1rem' },
};

export const blogDetailsHeroImageWrapperStyles = {
	borderRadius: '2.5rem 0 0 2.5rem',
	overflow: 'hidden',
	maxHeight: '18.75rem',
	display: 'block',
	minHeight: '18.75rem',
	flex: 1,
	width: '100%',
	position: { xs: 'relative' },
	right: { xs: '-1rem', md: '0' },
};
